<template>
  <div>
    <div id="videoList">
      <VideoItem
        class="videoItem-wrapper"
        v-for="(post, index) in posts"
        :key="index"
        :post="post"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import VideoItem from "./VideoItem.vue";
export default {
  name: "VideoList",
  props: ["posts"],
  components: {
    VideoItem,
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/youtube-styles.scss";

#videoList {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

// XXL screens — show 6 items per row
@media screen and (min-width: 1800px) {
  #videoList {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    padding: 24px;
  }
}

// XL screens — show 5 items per row
@media screen and (min-width: 1600px) and (max-width: 1799px) {
  #videoList {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 24px;
  }
}

// Large desktops — keep 4 columns
@media screen and (max-width: 1599px) {
  #videoList {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    padding: 20px;
  }
}

// Medium screens — 3 columns
@media screen and (max-width: 1200px) {
  #videoList {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }
}

// Tablets — 2 columns
@media screen and (max-width: 1000px) {
  #videoList {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 16px;
  }
}

// Phones — 1 column
@media screen and (max-width: 650px) {
  #videoList {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 12px;
  }
}

// Ensure full-width items inside the grid
.videoItem-wrapper {
  width: 100%;
}
</style>
